import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-login-or-sign-up',
    templateUrl: './login-or-sign-up.component.html',
    styleUrls: ['./login-or-sign-up.component.scss'],
    standalone: false
})
export class LoginOrSignupComponent {
  @Input() location: string;

  constructor() {}
}
